
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marquee",
      function () {
        return require("private-next-pages/marquee/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marquee"])
      });
    }
  